import React, { useEffect, useState } from "react";
import { UseTopPlayers, UseGroupKpis } from "../../../hooks/kpi";
import { useDispatch } from "react-redux";
import { setToLiveKpis } from "../../../redux/kpi/actions";

import LiveLeaderboardComponent from "./LiveLeaderboard";

const LiveLeaderboard = ({ periodIdx, kpiId, isAdmin = false }) => {
  const [topList, setTopList] = useState([]);
  const groupKpis = UseGroupKpis();
  const dispatch = useDispatch();

  const topPlayers = [
    UseTopPlayers("yesterday"),
    UseTopPlayers("today"), 
    UseTopPlayers("week"),
    UseTopPlayers("month"),
  ];

  useEffect(() => {
    dispatch(setToLiveKpis());
  }, []);

  useEffect(() => {
    if (!topPlayers[periodIdx]) return;

    const currentPlayers = topPlayers[periodIdx];
    const prevPlayers = JSON.stringify(topList);
    const newPlayers = kpiId === 'default' 
      ? currentPlayers
      : currentPlayers.map(player => ({
          ...player,
          scores: {
            ...player.scores,
            total: player.scores?.[kpiId]?.pts || 0
          }
        })).filter(player => player.scores?.[kpiId] !== undefined);

    if (JSON.stringify(newPlayers) !== prevPlayers) {
      setTopList(newPlayers);
    }
  }, [topPlayers[periodIdx], periodIdx, kpiId]);

  return (
    <LiveLeaderboardComponent
      topList={topList}
      groupKpis={groupKpis}
      isAdmin={isAdmin}
      periodIdx={periodIdx}
      kpiId={kpiId}
    />
  );
};

export default LiveLeaderboard;
